var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"bg"},[_c('card-login',{scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('span',{staticClass:"d-flex justify-center text-h6"},[_vm._v("Token inválido")])]},proxy:true},{key:"control",fn:function(){return [_c('v-row',[_c('v-col')],1),_c('v-row')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }